import EntityType from "../Entities/Type/EntityType";
import EntityDefinitions from "../Entities/App/EntityDefinitions";

class EntityApi {

    constructor(jsonApi) {
        this.jsonApi = jsonApi;
        this.db = sessionStorage.getItem('frontend.db');
    }

    getReadLink(type, id, flavor='vanilla') {
        return this.jsonApi.baseUrl + 'admin/entities/read.php?type='+type+'&id='+id+'&db='+this.db+(flavor ? '&flavor='+flavor : '');
    }

    getListLink(type) {
        return this.jsonApi.baseUrl + 'admin/entities/list.php?type='+type+'&db='+this.db
    }

    getDefinitionsUrl() {
        return this.jsonApi.baseUrl + 'admin/entities/?db='+this.db;
    }

    getDefinitionUrl(type) {
        return this.jsonApi.baseUrl + 'admin/entities/?type='+type+'&db='+this.db;
    }

    getDefinition(type, successFunction, errorFunction = null) {
        const path = 'admin/entities/index.php?type='+type+'&db='+this.db;
        this.jsonApi.get(path,
            (data) => {
                const et = new EntityType(data.data);
                successFunction(et)
            },
            errorFunction);
    }

    getDefinitions(successFunction, errorFunction = null) {
        const path = 'admin/entities/index.php?db='+this.db;
        this.jsonApi.get(path,
            (data) => {
                successFunction(data.data)
            },
            errorFunction);
    }

    get(type, id, flavor, successFunction, errorFunction = null, includeDefinition = false) {
        const path = 'admin/entities/read.php?type='+type+'&id='+id+'&db='+this.db+(flavor ? '&flavor='+flavor : '')
            +(includeDefinition ? '&definition=true' : '');
        this.jsonApi.get(path,
            (data) => {
                const et = new EntityType(data.data.definition || EntityDefinitions.getDefinition(data.data.type));
                successFunction(et, et.createEntity(data.data.entity))
            },
            errorFunction);
    }

    list(type, flavor, successFunction, errorFunction = null, changedAfter = false, filter = null, includeDefinition = false, changedAfterTypes) {
        const path = 'admin/entities/list.php?type=' + type + '&db=' + this.db + (flavor ? '&flavor=' + flavor : '')
            + (changedAfter !== false ? '&changedAfter=' + changedAfter : '')
            + (filter ? '&by_' + filter.key + '=' + filter.value : '')
            + (includeDefinition ? '&definition=1' : '')
            + (changedAfterTypes ? '&changedAfterTypes='+changedAfterTypes.join() : '');
        this.jsonApi.get(path,
            (data) => {
                const et = new EntityType(data.data.definition || EntityDefinitions.getDefinition(data.data.type));
                successFunction(et, et.createEntities(data.data.list), data);
            },
            errorFunction);
    }

    listWithBackup(type, flavor, successFunction, errorFunction = null) {
        const path = 'admin/entities/list.php?type='+type+'&db='+this.db+(flavor ? '&flavor='+flavor : '');
        this.jsonApi.get(path,
            (data) => {
                localStorage.setItem(this.db + '.entity.' + type + '.list', JSON.stringify(data.data.list));
                //localStorage.setItem(this.db + '.entity.' + type + '.definition', JSON.stringify(data.data.definition));

                const et = new EntityType(data.data.definition || EntityDefinitions.getDefinition(data.data.type));
                successFunction(et, et.createEntities(data.data.list))
            },
            (data) => {
                console.log(type + ' list fetch failed:'+data.message);
                console.log('Looking in local storage');
                //const def =  localStorage.getItem(this.db + '.entity.' + type + '.definition');
                const list = localStorage.getItem(this.db + '.entity.' + type + '.list');
                if (list) {
                    const et = new EntityType(EntityDefinitions.getDefinition(type));
                    successFunction(et, et.createEntities(list))
                }
                else if (errorFunction) {
                    errorFunction(data);
                }
            });
    }

    save(entity, flavor, successFunction, errorFunction = null, includeDefinition = false) {
        const json = entity.toJson();
        const action = json.id ? 'update.php?id='+json.id+'&' : 'create.php?';
        const path= 'admin/entities/'+action+'type='+entity.getTypeName()+'&db='+this.db+(flavor ? '&flavor='+flavor : '')
            +(includeDefinition ? '&definition=1' : '');
        this.jsonApi.post(path, json,
            (data) => {
                entity.id = data.data.entity.id;
                const et = new EntityType(data.data.definition || EntityDefinitions.getDefinition(data.data.type));
                successFunction(et.createEntity(data.data.entity), data)
            },
            errorFunction);
    }

    saveData(json, type, flavor, successFunction, errorFunction = null, includeDefinition = false) {
        const action = json.id ? 'update.php?id='+json.id+'&' : 'create.php?';
        const path= 'admin/entities/'+action+'type='+type+'&db='+this.db+(flavor ? '&flavor='+flavor : '')+
            (includeDefinition ? '&definition=1' : '');
        this.jsonApi.post(path, json,
            (data) => {
                const et = new EntityType(data.data.definition || EntityDefinitions.getDefinition(data.data.type));
                successFunction(et.createEntity(data.data.entity), data);
            },
            errorFunction);
    }

    updateList(entities, flavor, successFunction, errorFunction = null, includeDefinition = false) {
        const jsonList = entities.map(e => e.toJson());
        const path= 'admin/entities/update.php?type='+entities[0].getTypeName()+'&db='+this.db
            +(flavor ? '&flavor='+flavor : '')+(includeDefinition ? '&definition=1' : '');
        this.jsonApi.post(path, jsonList,
            (data) => {
                const et = new EntityType(data.data.definition || EntityDefinitions.getDefinition(data.data.type));
                successFunction(et, et.createEntities(data.data.list), data);
            },
            errorFunction);
    }

    delete(entity, successFunction, errorFunction = null) {
        const path = 'admin/entities/delete.php?type='+entity.getTypeName()+'&db='+this.db+'&id='+entity.getId();
        this.jsonApi.get(path, successFunction, errorFunction);
    }
}

export default EntityApi;